<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-card>
      <v-row>
        <v-card-title></v-card-title>
        <v-col cols="12" sm="6" md="2">
          <template>
            <v-autocomplete
                :items="doctors"
                item-text="dr_name"
                item-key="id"
                item-value="id"
                label="Doctor List"
                v-model="searchParam.doctor_id"
                :loading="loadingStatus"
                outlined
                dense
                chips
            ></v-autocomplete>
          </template>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="date"
                  label="Select Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
              ></v-text-field>
            </template>

            <v-date-picker v-model="date" range></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="2">
          <template>
            <v-autocomplete
                :items="users"
                item-text="full_name"
                item-value="id"
                item-key="id"
                label="Counselor Name"
                v-model="searchParam.user_id"
                :loading="loadingStatus"
                outlined
                dense
                chips
                hide-details
            ></v-autocomplete>
          </template>
        </v-col>
        <v-col cols="12" md="2">
          <template>
            <v-autocomplete
                :items="operations"
                item-text="name"
                item-value="id"
                item-key="id"
                label="Operation Name"
                v-model="searchParam.operation_id"
                :loading="loadingStatus"
                outlined
                dense
                chips
                hide-details
            ></v-autocomplete>
          </template>
        </v-col>

        <v-col md="1">
          <v-btn depressed color="primary" v-on:click="getFollowupData"
          ><v-icon>mdi-magnify</v-icon></v-btn>
        </v-col>
        <v-col md="1">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                  depressed
                  color="success"
                  v-on="on"
                  v-on:click="printList('excel')"
              >
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </template>
            <span>Download excel file</span>
          </v-tooltip>
        </v-col>
        <v-col md="1">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                  depressed
                  color="primary"
                  v-on="on"
                  v-on:click="printList('print')"
              >
                <v-icon>mdi-printer</v-icon>
              </v-btn>
            </template>
            <span>Print Report</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card>

    <div id="print">
      <v-card-title>OT Counseling Report</v-card-title>
      <v-data-table
          :headers="followUpHeaders"
          :items="followUpDessertsItemsWithSno"
          class="elevation-1"
          dense
          mobile-breakpoint="0"
          :loading="loadingStatus"
          loading-text="Loading... Please wait"
          disable-pagination
          :hide-default-footer="true"
      >
      </v-data-table>
    </div>
  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
import moment from "moment";
export default {
  data() {
    return {
      date: [
        moment().format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
      login_user_id: localStorage.getItem("userId"),
      menu2: false,
      menu3: false,
      loadingStatus: true,
      returnApiBaseUrl: atshq.defaults.headers.common.api_base_URL,
      doctors: [],
      operations: [],
      users: [],
      searchParam: {
        doctor_id: '',
        user_id: '',
        operation_id: '',
      },

      followUpHeaders: [
        {text: "#", value: "sno",},
        {text: "Operation Name", value: "operation.name"},
        {text: "Total Counseling", value: "total_counseling"},
        { text: "Total OT Done", value: "total_ot_done" },
        { text: "Total Active OT", value: "total_active" },
        { text: "Total Not Interested", value: "total_not_interested" },
      ],
      followUpDesserts: [],
      items: [
        {text: "Dashboard", disabled: false, href: "/",},
        {text: "OT Counseling", disabled: false, href: "/",},
        {text: "Counseling Report", disabled: true, href: "",},
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.getDoctors();
    this.getFollowupData();
    this.getUsers();
    this.getOperations();
  },
  computed: {
    followUpDessertsItemsWithSno() {
      return this.followUpDesserts.map((d, index) => ({...d, sno: index + 1}));
    },
  },
  methods: {
    getUsers() {
      atshq
          .get("users/user")
          .then((response) => {
            this.users = response.data.data;
            this.loadingStatus = false;
          })
          .catch((e) => {
            // this.errors.push(e);
            console.log(e);
          });
    },
    getDoctors() {
      atshq
          .get("doctors?status=1")
          .then((response) => {
            this.doctors = response.data.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    getOperations() {
      atshq
          .get("/operations")
          .then((response) => {
            this.operations = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    getFollowupData() {
      this.loadingStatus = true;
      if (this.date.length === 1) {
        this.$noty.error("Opps !! Please Select Date ranges.");
        return false;
      }
      console.log(this.searchParam)
      atshq
          .get(
              "ot-module/ot-counseling-report-data?date=" +
              this.date +
              "&doctor_id=" +
              this.searchParam.doctor_id +
              "&user_id=" +
              this.searchParam.user_id+
              "&operation_id=" +
              this.searchParam.operation_id
          )
          .then((response) => {
            this.loadingStatus = false;
            this.followUpDesserts = response.data.patientFollowupReports;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    printList(type) {
      window.open(this.returnApiBaseUrl + "print/counseling-report?type="+ type + "&date=" + this.date +
      "&doctor_id=" + this.searchParam.doctor_id + "&user_id=" + this.searchParam.user_id + "&operation_id=" + this.searchParam.operation_id)
    }
  },
};
</script>
